import { getUserConfiguration } from 'owa-session-store';
import { HMPlusBit } from 'owa-domain-connect';
import getGoDaddyDomainDetailsAction from '../orchestrators/getGoDaddyDomainDetails';
import { isFeatureEnabled } from 'owa-feature-flags';
import store from '../store/store';
import { fetchLegacyUserDomainData } from '../actions/fetchLegacyUserDomainData';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export function isTransferDomainOptionHidden(): boolean {
    var isHidden = false;
    if (isConsumer()) {
        fetchLegacyUserDomainData();
        getGoDaddyDomainDetailsAction(null);
        // legacy byod
        isHidden = store.legacyPremiumTenant.DomainPurchaseType == 1;
    }
    var isLegacyPremiumTenantEmpty = store.legacyPremiumTenant.TenantName == null;
    return (
        isHidden ||
        (!getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !isFeatureEnabled('auth-PremiumTransferDomainTab') ||
            isLegacyPremiumTenantEmpty ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) !== HMPlusBit)
    );
}
